<script>
import { deleteBiomarker } from '../services/biomarkerService'
import { BIOMARKERS } from '../graphql/queries/BiomarkerQueries'
import { ContentLoader } from 'vue-content-loader'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'BiomarkerListAdminView',
  components: { ContentLoader },
  data() {
    return {
      isMobile: isMobile
    }
  },
  apollo: {
    biomarkers: {
      query: BIOMARKERS,
      result() {
        this.sortTable()
      }
    }
  },
  methods: {
    sortTable() {
      this.$nextTick(function() {
        this.$refs.biomarkerTable.initSort()
      })
    },
    deleteBiomarker(biomarker) {
      const oldBiomarkers = [...this.biomarkers]

      this.biomarkers = this.biomarkers.filter(x => x.id !== biomarker.id)

      const deleteTimeout = setTimeout(async () => {
        try {
          await deleteBiomarker(biomarker.id)
        } catch (error) {
          this.biomarkers = oldBiomarkers
          console.log(error)
        }
      }, 5000)

      this.$snackbar.open({
        duration: 5000,
        message: `Biomarker "${biomarker.name}" deleted`,
        type: 'is-secondary',
        position: 'is-bottom-left',
        actionText: 'Undo',
        onAction: () => {
          clearTimeout(deleteTimeout)
          this.biomarkers = oldBiomarkers
        }
      })
    }
  }
}
</script>

<template>
  <div class="container section">
    <ContentLoader
      v-if="$apollo.loading"
      :height="150"
      :width="isMobile ? 200 : 400"
      :speed="3"
    >
      <rect x="0" y="0" rx="3" ry="3" width="155" height="12" />
      <rect x="0" y="20" rx="3" ry="3" width="350" height="4" />
      <rect x="0" y="30" rx="3" ry="3" width="380" height="4" />
      <rect x="0" y="40" rx="3" ry="3" width="201" height="4" />
    </ContentLoader>
    <div v-show="!$apollo.loading">
      <div class="has-text-right">
        <router-link
          :to="{
            name: 'BiomarkerAddView'
          }"
          tag="button"
          class="button is-rounded is-primary"
          >Add biomarker</router-link
        >
      </div>
      <b-table
        ref="biomarkerTable"
        :data="biomarkers"
        default-sort="name"
        class="is-centered"
        hoverable
      >
        <template slot-scope="props">
          <b-table-column field="type" label="Type" width="25" sortable>
            <span
              :class="[
                'tag',
                { 'is-accent': props.row.type == 'BLOOD' },
                { 'is-warning': props.row.type == 'URINE' },
                { 'is-info': props.row.type == 'SALIVA' },
                { 'is-secondary': props.row.type == 'OTHER' }
              ]"
              >{{ props.row.type }}</span
            >
          </b-table-column>
          <b-table-column field="name" label="Biomarker" sortable>{{
            props.row.name
          }}</b-table-column>
          <b-table-column
            field="synonyms"
            label="Synonyms"
            class="has-text-tertiary"
            >{{ props.row.synonyms.join(', ') | truncate(75) }}</b-table-column
          >
          <b-table-column field="actions" width="150" class="has-text-right">
            <router-link
              :to="{
                name: 'BiomarkerEditView',
                params: { id: props.row.id }
              }"
              class="button is-light has-text-tertiary is-small"
              >Edit</router-link
            >&nbsp;&nbsp;
            <button
              class="button is-light has-text-tertiary is-small"
              @click="deleteBiomarker(props.row)"
            >
              ×
            </button>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<style scoped lang="sass">
.biomarker-item
  margin-top: 10px
</style>
